// Reloads the WordPress admin bar for logged-in users after a Barba transition
export function reloadWpAdminBar() {
  if (document.querySelector('.logged-in')) {
    fetch(window.location.href, { credentials: 'same-origin' })
      .then(response => response.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const newAdminBar = tempDiv.querySelector('#wpadminbar');
        const currentAdminBar = document.querySelector('#wpadminbar');
        if (newAdminBar && currentAdminBar) {
          currentAdminBar.replaceWith(newAdminBar);
        }
      });
  }
  const megaMenu = document.getElementById('mega-menu-wrap-menu-primary');
  if (megaMenu) {
    fetch(location.href, { credentials: 'same-origin' })
      .then(res => res.text())
      .then(markup => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = markup;
        const freshMenu = wrapper.querySelector('#mega-menu-wrap-menu-primary');
        if (freshMenu) {
          megaMenu.replaceWith(freshMenu);
          reinitMaxMegaMenu();
        }
      })
      .catch(() => {});
  }
}

function reinitMaxMegaMenu() {
  const jq = window.jQuery || window.$;
  if (!jq || !jq.fn || typeof jq.fn.maxmegamenu !== 'function') return;

  jq('ul.max-mega-menu').each(function () {
    const api = jq(this).data('maxmegamenu');
    if (api) return;
    try {
      jq(this).maxmegamenu();
    } catch (_) {}
  });
}
